import type { EligibleDiscount } from '@library/api-promotions'

export type DiscountBadge = {
  collapsedText: string
  expandedText: string
  // Exactly one of these is set, matching the discount type.
  offeredPct: number | null
  offeredFixed: number | null
}

const formatAmount = (amount: number): string =>
  `£${Number.isInteger(amount) ? amount : amount.toFixed(2)}`

export const buildDiscountBadge = (discount: EligibleDiscount): DiscountBadge | null => {
  const amount = Number(discount.amount)

  // A malformed amount would render "NaN% off" on a customer-facing badge; hide it instead.
  if (!Number.isFinite(amount)) {
    return null
  }

  const isPercentage = discount.type === 'percentageOffOrder'
  const value = isPercentage ? `${amount}%` : formatAmount(amount)

  return {
    collapsedText: `${value} off`,
    expandedText: `${value} discount applied`,
    offeredPct: isPercentage ? amount : null,
    offeredFixed: isPercentage ? null : amount,
  }
}
